/* global TradeInValuations */

import React, { Component } from "react"
import PropTypes from "prop-types"
import SendPicturesSms from "./SendPicturesSms"

import TestDriveFormSummary from "../TradeInValuations/TestDriveBookingFlow/TestDriveFormSummary"

class TradeInResult extends Component {
  static propTypes = {
    carSummaryHtml: PropTypes.string.isRequired,
    displayValuation: PropTypes.bool.isRequired,
    pricingExplanation: PropTypes.string.isRequired,
    pricingResult: PropTypes.string.isRequired,
    resultHeading: PropTypes.string.isRequired,
    sendPicturesSmsProps: PropTypes.object,
    bookingSummaryProps: PropTypes.object,
    trackFunction: PropTypes.func,
  }

  componentDidMount() {
    TradeInValuations.hideHeaderTitle()
    this.props.trackFunction({
      entity: "valuation_result",
      action: "displayed",
      type: "macro_proceeding",
      flow: "trade_in",
    })
  }

  render() {
    const { props } = this
    return (
      <div className="result">
        <h2
          className={`label ${!props.displayValuation && "no-estimate"}`}
          dangerouslySetInnerHTML={{ __html: props.resultHeading }}
        />
        <div className="estimated-price">{props.pricingResult}</div>
        <div className="valuation-summary">
          {props.displayValuation ? (
            <React.Fragment>
              <div
                dangerouslySetInnerHTML={{ __html: props.pricingExplanation }}
              />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div
                className="notice"
                dangerouslySetInnerHTML={{ __html: props.pricingExplanation }}
              />
            </React.Fragment>
          )}
          <SendPicturesSms
            {...props.sendPicturesSmsProps}
            startHidden
            trackFunction={this.props.trackFunction}
          />
        </div>
        {this.props.carSummaryHtml && (
          <div
            className="car-summary"
            style={
              this.props.bookingSummaryProps ? { marginBottom: "6px" } : {}
            }
            dangerouslySetInnerHTML={{ __html: this.props.carSummaryHtml }}
          />
        )}
        {this.props.bookingSummaryProps && (
          <TestDriveFormSummary
            tradeInValuation={this.props.bookingSummaryProps.tradeInValuation}
            department={this.props.bookingSummaryProps.department}
            showHeadline={false}
            translations={this.props.bookingSummaryProps.translations}
            bookingTime={this.props.bookingSummaryProps.bookingTime}
          />
        )}
      </div>
    )
  }
}

export default TradeInResult
